import GoogleMeetSettings from '@/admin/pages/settings/google-meet-settings';
import {
	googleCredentialsQuery,
	googleStatusQuery,
} from '@/admin/queries/google';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/google-meet')({
	loader: ({ context }) =>
		Promise.all([
			context.queryClient.ensureQueryData(googleStatusQuery()),
			__ALLCOACH_ADMIN__.isAdmin
				? context.queryClient.ensureQueryData(googleCredentialsQuery())
				: Promise.resolve(),
		]),
	component: GoogleMeetSettings,
});
